import { useState } from 'react';
import {
    NJButton,
    NJIcon,
    NJIconButton,
    NJSegmentedControl,
    NJSegmentedControlButton,
    NJText,
} from '@engie-group/fluid-design-system-react';
import { VIEWER_IDS, VIEWERS, type ViewerId } from './permissions';

interface ViewerSwitcherProps {
    viewer: ViewerId;
    onChange: (viewer: ViewerId) => void;
    onReset: () => void;
}

export default function ViewerSwitcher({ viewer, onChange, onReset }: ViewerSwitcherProps) {
    const [open, setOpen] = useState(false);
    const activeViewer = VIEWERS[viewer];

    return (
        <aside
            aria-label="Contrôles du prototype"
            style={{
                position: 'fixed',
                right: 24,
                bottom: 56,
                zIndex: 9000,
                width: open ? 350 : 'auto',
                background: 'var(--nj-semantic-color-background-neutral-primary-default)',
                border: '2px dashed var(--nj-semantic-color-border-brand-moderate-default)',
                borderRadius: 'var(--nj-semantic-size-border-radius-md, 8px)',
                boxShadow: '0 8px 24px rgba(0, 0, 0, 0.18)',
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 8px 8px 16px' }}>
                <NJIcon name="science" size="sm" />
                <NJText scale="sm" style={{ fontWeight: 700, flex: 1 }}>
                    Prototype — {open ? 'Voir en tant que' : activeViewer.label}
                </NJText>
                <NJIconButton
                    icon={open ? 'expand_more' : 'expand_less'}
                    label={open ? 'Réduire les contrôles du prototype' : 'Ouvrir les contrôles du prototype'}
                    size="sm"
                    onClick={() => setOpen((value) => !value)}
                />
            </div>
            {open && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 12, padding: '0 16px 16px' }}>
                    <NJSegmentedControl
                        label="Voir en tant que"
                        size="sm"
                        value={viewer}
                        onChange={(value) => {
                            if (VIEWER_IDS.includes(value as ViewerId)) onChange(value as ViewerId);
                        }}
                    >
                        {VIEWER_IDS.map((id) => (
                            <NJSegmentedControlButton key={id} label={VIEWERS[id].label} value={id} />
                        ))}
                    </NJSegmentedControl>
                    <NJText scale="sm" variant="secondary">
                        {activeViewer.description}
                    </NJText>
                    <NJButton
                        label="Réinitialiser le schéma"
                        variant="secondary"
                        emphasis="minimal"
                        scale="sm"
                        icon="restart_alt"
                        onClick={onReset}
                    />
                </div>
            )}
        </aside>
    );
}
